import { useCallback } from "react";
import { useDashboardEditorContext } from "../../../../../../hook/context/editor";
import { useGUIEditorContext } from "../../../../../../hook/context/gui";

export const useLayerRemoveEncodingCallback = (layerPosition: number, axis: "x" | "y") => {
  const editor = useDashboardEditorContext();
  const { block, preset } = useGUIEditorContext();

  return useCallback(() => {
    if (!block) return;

    const layers = block.config.layers
      .map((layer, i) => ({
        ...layer,
        encoding: {
          ...layer.encoding,
          ...(preset === "line"
            ? i === layerPosition
              ? {
                  x: { identifier: "", column: "", quantity: undefined },
                  y: { identifier: "", column: "", quantity: undefined },
                }
              : {}
            : {
                [axis]:
                  i === layerPosition
                    ? {
                        identifier: "",
                        column: "",
                        quantity: undefined,
                      }
                    : layer.encoding[axis],
              }),
        },
      }))
      .filter(layer =>
        preset === "line"
          ? layer.encoding.y.identifier.length > 0
          : layer.encoding.x.identifier.length > 0 || layer.encoding.y.identifier.length > 0,
      );

    void editor?.updateBlock({
      ...block,
      config: {
        ...block.config,
        layers,
      },
    });
  }, [axis, block, editor, layerPosition, preset]);
};
